import numeral from 'numeral';

export const baseNumberFormatter = (value) => {
    const num = Number(value);
    return isNaN(num) ? '0' : numeral(num).format('0,0');
};

export const moneyFormatter = (value) => {
    const num = Number(value);
    return isNaN(num) ? '0' : numeral(num).format('$0,0.[00]');
};

export const percentFormatter = (value) => {
    const num = Number(value);
    return isNaN(num) ? '0%' : numeral(num / 100).format('0.[00]%');
};
